import React, { Component } from "react";
import { Col, Row } from "antd";
import SwitchLanguageButton from "./../LangSwitcher";
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from "react-intl";
import messages from "./messages";
import logo from "./../../assets/images/logo.svg";
import Flexbox from "flexbox-react";
// import us_icon from '../../assets/images/us_icon.svg';

const Footer = ({ children }) => <div className="ant-layout-footer Footer">{children}</div>;


const FacebookSvg = () => {
	return <svg width="8" height="17" viewBox="0 0 8 17" version="1.1"
		xmlns="http://www.w3.org/2000/svg">
		<defs>
			<linearGradient id="gradient" gradientUnits="userSpaceOnUse" fy="90%">
				<stop offset="0" style={{ stopColor: "#18A5CF" }} />
				<stop offset="1" style={{ stopColor: "#333CCD" }} />
			</linearGradient>
			<mask id="facebook" maskUnits="userSpaceOnUse" x="0" y="0" width="8" height="17">
				<path
					d="M 8 5.50375L 5.28 5.50375L 5.28 3.74C 5.28 3.08125 5.728 2.92188 6.03733 2.92188L 7.95733 2.92188L 7.95733 0.010625L 5.312 0C 2.368 0 1.696 2.1675 1.696 3.55938L 1.696 5.50375L 0 5.50375L 0 8.51062L 1.696 8.51062L 1.696 17L 5.28 17L 5.28 8.51062L 7.69067 8.51062L 8 5.50375"
					fill="#CCCCD2" />
			</mask>
		</defs>
		<g mask="url(#facebook)">
			<rect x="0" y="0" width="8" height="17" fill="#CCCCD2" />
			<rect id="imageGradient" x="0" y="0" width="8" height="17"
				fill="url(#gradient)" />
		</g>
	</svg>
};
const TwitterSvg = () => {
	return <svg width="17" height="13" viewBox="0 0 17 13" version="1.1"
		xmlns="http://www.w3.org/2000/svg">
		<defs>
			<linearGradient id="gradient" gradientUnits="userSpaceOnUse" fy="90%">
				<stop offset="0" style={{ stopColor: "#18A5CF" }} />
				<stop offset="1" style={{ stopColor: "#333CCD" }} />
			</linearGradient>
			<mask id="twitter" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="13">
				<path
					d="M 13.2632 2.03L 13.2347 2C 12.6095 1.41 11.8895 1.13 11.0463 1.17L 11.0179 1.1L 11.0368 1.1C 11.7947 0.92 12.2495 0.74 12.3821 0.54C 12.4295 0.38 12.3726 0.3 12.2021 0.27C 11.8232 0.32 11.4726 0.41 11.16 0.53C 11.5579 0.27 11.7095 0.09 11.6242 0C 11.2263 0.01 10.8 0.21 10.3547 0.61C 10.5253 0.33 10.5821 0.17 10.5442 0.15C 10.3358 0.3 10.1463 0.46 9.98526 0.63C 9.65368 1.01 9.37895 1.36 9.17053 1.68L 9.16105 1.71C 8.63053 2.58 8.26105 3.46 8.03368 4.36L 7.95789 4.43L 7.93895 4.44C 7.61684 4.03 7.23789 3.69 6.77368 3.42C 6.23368 3.06 5.59895 2.72 4.86 2.39C 4.06421 1.97 3.24947 1.62 2.42526 1.35C 2.42526 2.28 2.87053 3.03 3.76105 3.57L 3.76105 3.58C 3.44842 3.58 3.14526 3.63 2.85158 3.72C 2.90842 4.58 3.51474 5.18 4.66105 5.51L 4.65158 5.53C 4.20632 5.5 3.83684 5.66 3.54316 5.99C 3.92211 6.74 4.58526 7.09 5.55158 7.07C 5.36211 7.17 5.21053 7.28 5.11579 7.4C 4.93579 7.59 4.87895 7.81 4.93579 8.06C 5.14421 8.44 5.52316 8.61 6.06316 8.59L 6.10105 8.63L 6.08211 8.64C 5.13474 9.63 3.99789 10.08 2.65263 9.99L 2.63368 10C 1.81895 9.99 0.937895 9.59 0 8.8C 0.947368 10.19 2.20737 11.19 3.77053 11.82C 5.56105 12.42 7.35158 12.46 9.13263 11.95L 9.16105 11.95C 10.8947 11.44 12.3632 10.4 13.5758 8.83C 14.1347 8 14.4853 7.22 14.6274 6.46C 15.5274 6.49 16.1811 6.23 16.5884 5.67L 16.5789 5.65C 16.2758 5.76 15.6884 5.73 14.8074 5.55L 14.8074 5.45C 14.8074 5.44 14.8074 5.44 14.8168 5.45C 15.7737 5.34 16.3326 5.03 16.5221 4.51C 15.8495 4.77 15.1958 4.78 14.5421 4.53C 14.4284 3.62 14.0021 2.78 13.2632 2.03"
					fill="#CCCCD2" />
			</mask>
		</defs>
		<g mask="url(#twitter)">
			<rect x="0" y="0" width="17" height="13" fill="#CCCCD2" />
			<rect id="imageGradient" x="0" y="0" width="17" height="13"
				fill="url(#gradient)" />
		</g>
	</svg>
};
const InstagramSvg = () => {
	return <svg width="14" height="14" viewBox="0 0 14 14" version="1.1"
		xmlns="http://www.w3.org/2000/svg">
		<defs>
			<linearGradient id="gradient" gradientUnits="userSpaceOnUse" fy="90%">
				<stop offset="0" style={{ stopColor: "#18A5CF" }} />
				<stop offset="1" style={{ stopColor: "#333CCD" }} />
			</linearGradient>
			<mask id="instagram" maskUnits="userSpaceOnUse" x="0" y="0" width="14"
				height="14">
				<path
					d="M 10.5187 6.21606C 10.836 6.51473 10.864 6.82273 10.864 7.13073C 10.864 9.3054 9.13733 11.0507 7.00933 11.0507C 4.88133 11.0507 3.14533 9.3054 3.14533 7.13073C 3.14533 6.82273 3.18267 6.51473 3.26667 6.21606L 0 6.21606L 0 12.7494C 0 13.4307 0.532 14.0001 1.16667 14.0001L 12.8333 14.0001C 13.468 14.0001 14 13.4307 14 12.7494L 14 6.21606L 10.5187 6.21606ZM 9.268 7.19593C 9.268 8.5586 8.19467 9.66927 6.888 9.66927C 5.58133 9.66927 4.51733 8.5586 4.51733 7.19593C 4.51733 5.83327 5.58133 4.73193 6.888 4.73193C 8.19467 4.73193 9.268 5.83327 9.268 7.19593ZM 13.048 2.87476C 13.048 3.09876 12.8333 3.28543 12.5627 3.28543L 10.7053 3.28543C 10.4347 3.28543 10.2013 3.09876 10.2013 2.87476L 10.2013 1.35343C 10.2013 1.12943 10.4347 0.961426 10.7053 0.961426L 12.5627 0.961426C 12.8333 0.961426 13.048 1.12943 13.048 1.35343L 13.048 2.87476ZM 12.7493 0L 1.16667 0C 0.532 0 0 0.569333 0 1.204L 0 4.228L 4.51733 4.228C 5.22667 3.71467 5.98267 3.276 6.888 3.276C 7.77467 3.276 8.568 3.71467 9.268 4.228L 14 4.228L 14 1.204C 14 0.569333 13.4307 0 12.7493 0Z"
					fill="#CCCCD2" />
			</mask>
		</defs>
		<g mask="url(#instagram)">
			<rect x="0" y="0" width="14" height="14" fill="#CCCCD2" />
			<rect id="imageGradient" x="0" y="0" width="14" height="14"
				fill="url(#gradient)" />
		</g>
	</svg>
};

class F extends Component {
	render() {
		return (
			<Footer>
				<Row type="flex" justify="space-between">
					<Col sm={{ span: 2, offset: 0 }} span={2}>
						<Flexbox flexDirection="column" align="space-between">
							<img className="logo" src={logo} alt="logo" /><br />
							<Flexbox
								className="social"
								justifyContent="space-around">
								<a href="/">
									<FacebookSvg />
								</a>
								<a href="/">
									<TwitterSvg />
								</a>
								<a href="/">
									<InstagramSvg />
								</a>
							</Flexbox>
						</Flexbox>
					</Col>
					{
						messages.ourAddresses.map(address => (
							<Col span={6} className="contacts">
								<FormattedHTMLMessage {...address} />
							</Col>
						))
					}
				</Row>
				<Row type="flex" justify="space-between">
					<Col xs={{ span: 24, order: 3 }} md={{ span: 12, order: 1 }} lg={{ span: 16, order: 1 }}
						className="copyright">
						<FormattedMessage {...messages.copyright} />
					</Col>
					<Col xs={{ span: 24, order: 1 }} md={{ span: 8, order: 2 }} lg={{ span: 6, order: 2 }}
						className="privacy">
						<Flexbox alignItems="flex-end" justifyContent="flex-end">
							<Flexbox>
								<a href="/"><FormattedMessage {...messages.privacy} /></a>
							</Flexbox>
							<Flexbox>
								<a href="/faq"><FormattedMessage {...messages.terms} /></a>
							</Flexbox>
						</Flexbox>
					</Col>
					<Col xs={{ span: 24, order: 2 }} md={{ span: 2, order: 3 }} className="lang">
						<Flexbox>
							<SwitchLanguageButton />
						</Flexbox>
					</Col>
				</Row>
			</Footer>
		)
	}
}

export default injectIntl(F);





// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js